var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSubscriptionPlan(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 198.43 198.43",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_0_100a7b8610cae9479ac5e42cb44d14167f98008e01a6f2adac085b327e06fc33",
    x1: 70.43,
    y1: 56.11,
    x2: 109.74,
    y2: 56.11,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "var(--icon-menu-gradient-start, #7a0399)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "var(--icon-menu-gradient-end, #b10372)"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "MI_4L_main",
    d: "M59.15 16.49h84.16v111.43H59.15z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "MI_4L_stroke",
    d: "M100.07 105.14h31.26v11.18h-31.26zM117.68 57.51l4.17 3.64 9.11-9.66"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "MI_4L_gradient",
    stroke: "url(#SVGID_0_100a7b8610cae9479ac5e42cb44d14167f98008e01a6f2adac085b327e06fc33)",
    d: "M71.68 56.11h36.81"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "MI_4L_stroke",
    d: "M117.68 71.52l4.17 3.63 9.11-9.65"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "MI_4L_gradient",
    stroke: "url(#SVGID_0_100a7b8610cae9479ac5e42cb44d14167f98008e01a6f2adac085b327e06fc33)",
    d: "M71.68 70.11h36.81"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "MI_4L_stroke",
    d: "M117.68 85.53l4.17 3.63 9.11-9.66"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "MI_4L_gradient",
    stroke: "url(#SVGID_0_100a7b8610cae9479ac5e42cb44d14167f98008e01a6f2adac085b327e06fc33)",
    d: "M71.68 84.12h36.81"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "MI_4L_main",
    d: "M71.36 29.69h58.39M79.91 37.02h39.58"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSubscriptionPlan);
export default __webpack_public_path__ + "static/media/subscriptionPlan.1a93fc5e2ae7c70c52d49d6b575e7a29.svg";
export { ForwardRef as ReactComponent };